
































import { createComponent, computed } from "@vue/composition-api";
// eslint-disable-next-line
import { UnitsAndCaloriesPerDay } from "../types/drinkingDay";
import { getDailyUnitsForEachWeekDay } from "@dcc/common/weeklyDailyUnitsUtils";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";

interface DrinkFreeDaysPanelProps {
  drinkFreeDays: number[];
  unitsAndCaloriesPerDay: UnitsAndCaloriesPerDay[];
}

export default createComponent({
  props: {
    drinkFreeDays: Array as () => number[],
    unitsAndCaloriesPerDay: Array as () => UnitsAndCaloriesPerDay[]
  },

  setup(props: Readonly<DrinkFreeDaysPanelProps>) {
    const dictionary = useDictionary();
    const dailyUnits = computed(() =>
      getDailyUnitsForEachWeekDay({
        drinkFreeDays: props.drinkFreeDays,
        unitsAndCaloriesPerDay: props.unitsAndCaloriesPerDay
      })
    );

    return {
      dailyUnits,
      roundToNDecimalPlaces,
      ...dictionary
    };
  }
});
